module.exports = __webpack_public_path__ + "img/tiktok.1aebb436.svg";